export const ADD_COUNT = "ADD_COUNT";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
// ----------------- [ JOBS REDUCER ]
export const ADD_JOB = "ADD_JOB";
export const ADD_JOBS = "ADD_JOBS";
// ----------------- [ MEETINGS REDUCER ]
export const ADD_MEETINGS = "ADD_MEETINGS";
// ----------------- [ CHATS REDUCER ]
export const STORE_CHATS = "STORE_CHATS";
export const APPEND_CHATS = "APPEND_CHATS";
export const UPDATE_CHATS = "UPDATE_CHATS";
export const READ_CHAT = "READ_CHAT";
export const SET_MEETING = "SET_MEETING";

export const SUB_SUCCESS = "http://go2work-dev.web.app";
export const LINKEDIN_REDIRECT_URI = "https://go2work.com/callback";

// Trades Passport CTA destinations.
export const EMPLOYER_SIGNUP_URL = "https://www.go2work.com";
export const APP_STORE_URL = "https://apps.apple.com/us/app/go2work-app/id1659693434";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.go2work.app";

export const STORE_NOTIFICATIONS = "STORE_NOTIFICATIONS";
export const APPEND_NOTIFICATIONS = "APPEND_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DECLINE_OFFER = "DECLINE_OFFER";
export const ACCEPT_OFFER = "ACCEPT_OFFER";
export const DECLINE_INTERVIEW = "DECLINE_INTERVIEW";
export const ACCEPT_INTERVIEW = "ACCEPT_INTERVIEW";
export const DATA_FETCHED = "DATA_FETCHED";
export const DATA_FETCHING = "DATA_FETCHING";
export const ACCEPT_JOB = "ACCEPT_JOB";
export const DECLINE_JOB = "DECLINE_JOB";

export const EMPLOYER_PERMISSIONS = [];

export const OPENSTREETMAP_API_URL = "https://nominatim.openstreetmap.org";

export const COMMON_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "aol.com",
  "mail.com",
  "zoho.com",
  "inbox.com",
  "protonmail.com",
  "fastmail.com",
  "hushmail.com",
];

// Common construction & skilled-trades skills suggested in the Job Seeker
// onboarding skills picker. Curated frontend list (there is no skills master
// API); users can still add any skill not present here.
export const COMMON_TRADE_SKILLS = [
  "Blueprint Reading",
  "Bricklaying",
  "Cabinet Making",
  "Carpentry",
  "Caulking",
  "Concrete Finishing",
  "Concrete Forming",
  "Crane Operation",
  "Demolition",
  "Drywall Finishing",
  "Drywall Installation",
  "Electrical Wiring",
  "Equipment Maintenance",
  "Estimating",
  "Excavation",
  "Finish Carpentry",
  "Fire Sprinkler Installation",
  "Flooring Installation",
  "Forklift Operation",
  "Framing",
  "Glazing",
  "Grading",
  "Hardwood Flooring",
  "Heavy Equipment Operation",
  "HVAC Installation",
  "HVAC Repair",
  "Insulation Installation",
  "Ironwork",
  "Landscaping",
  "Masonry",
  "Material Handling",
  "Millwork",
  "Painting",
  "Pipefitting",
  "Plastering",
  "Plumbing",
  "Project Management",
  "Rebar Installation",
  "Rigging",
  "Roofing",
  "Safety Compliance",
  "Scaffolding",
  "Sheet Metal Work",
  "Site Supervision",
  "Solar Panel Installation",
  "Steel Erection",
  "Surveying",
  "Tiling",
  "Waterproofing",
  "Welding",
];

export const SUBSCRIPTION_PLANS = [
  {
    title: "go2work Standard Plan",
    key: "standard",
    identifier: "Standard Monthly",
  },
  {
    title: "go2work Premium Plan",
    key: "premium",
    identifier: "Premium Monthly",
  },
  {
    title: "go2work Pro Plan",
    key: "pro",
    identifier: "Pro Monthly",
  },
];

export const SUBSCRIPTION_PURCHASE_TYPE = {
  BUY: "buy",
  CANCEL: "cancel",
  UPGRADE: "upgrade",
};

export const PERMISSIONS = {
  jobs: "JOBS",
  chats: "CHATS",
  job_paused: "JOB_PAUSED",
  post_job_limit: "POST_JOBS_LIMIT",
  request_to_apply_limit: "REQUEST_TO_APPLY_LIMIT",
  teammates: "TEAMMATES",
  organizations: "ORGANIZATIONS",
  subscription: "SUBSCRIPTION",
  subscription_expired: "SUBSCRIPTION_EXPIRED",
  trial: "TRIAL",
  verification_checks: "VERIFICATION_CHECKS",
};

export const MAX_UPLOAD_SIZE = 1024 * 1024 * 10;
export const ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
];

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_FILE_SIZE_MB_FOR_VIDEO = 40;
export const MAX_FILE_SIZE_BYTES_FOR_VIDEO = MAX_FILE_SIZE_MB_FOR_VIDEO * 1024 * 1024;

// Re-export emoji constants
export * from "./emojiConstants";
